import { createAsyncThunk } from "@reduxjs/toolkit";

import 'react-toastify/dist/ReactToastify.css';
import { GetAttendanceStatus, GetOverallUpdates, GetMonthlyUpdates, AddNewDailyUpdate, GetWeeklyAISummary, GetMonthlyAISummary, GetOverallAISummary } from "helpers/api_method";

export const getMonthlyUpdate = createAsyncThunk("dailyupdates/getMonthlyUpdate", async (event: any) => {
    try {
        const response = await GetMonthlyUpdates(event.user_name,event.month,event.year);
        return response.data;
    } catch (error) {
        return error;
    }
});

export const getAttendanceStatusUpdate = createAsyncThunk("dailyupdates/getAttendanceStatusUpdate", async () => {
    try {
        const response = await GetAttendanceStatus();
        return response.data;
    } catch (error) {
        return error;
    }
});

export const getOverAllEmployeeUpdates = createAsyncThunk("dailyupdates/getOverAllEmployeeUpdates", async (event: any) => {
    try {
        const response = await GetOverallUpdates(event.month,event.year);
        return response.data;
    } catch (error) {
        return error;
    }
});

export const createNewDailyUpdate = createAsyncThunk("dailyupdates/createNewDailyUpdate", async (event: any) => {
    try {
        const response = await AddNewDailyUpdate(event);
        return response.data;
    } catch (error) {
        return error;
    }
});

export const getWeeklyAISummary = createAsyncThunk("dailyupdates/getWeeklyAISummary", async (event: any, { rejectWithValue }) => {
    try {
        const response = await GetWeeklyAISummary(event.weekStart, event.weekEnd);        
        // Check if the response indicates an error
        if (response && typeof response === 'object' && 'status' in response && (response as any).status === false) {
            return rejectWithValue((response as any).message || 'Failed to generate weekly summary');
        }
        
        return response;
    } catch (error: any) {
        console.error('Weekly AI Summary Error:', error);
        return rejectWithValue(error.response?.data || error.message || 'Failed to generate weekly summary');
    }
});

export const getMonthlyAISummary = createAsyncThunk("dailyupdates/getMonthlyAISummary", async (event: any, { rejectWithValue }) => {
    try {
        const response = await GetMonthlyAISummary(event.month, event.year);
        
        // Check if the response indicates an error
        if (response && typeof response === 'object' && 'status' in response && (response as any).status === false) {
            return rejectWithValue((response as any).message || 'Failed to generate monthly summary');
        }
        
        return response;
    } catch (error: any) {
        console.error('Monthly AI Summary Error:', error);
        return rejectWithValue(error.response?.data || error.message || 'Failed to generate monthly summary');
    }
});

export const getOverallAISummary = createAsyncThunk("dailyupdates/getOverallAISummary", async (event: any, { rejectWithValue }) => {
    try {
        const response = await GetOverallAISummary(event.month, event.year);        
        // Check if the response indicates an error
        if (response && typeof response === 'object' && 'status' in response && (response as any).status === false) {
            return rejectWithValue((response as any).message || 'Failed to generate overall summary');
        }
        
        return response;
    } catch (error: any) {
        console.error('Overall AI Summary Error:', error);
        return rejectWithValue(error.response?.data || error.message || 'Failed to generate overall summary');
    }
});

// Export gamification thunks
export {
    getGamificationStats,
    updateGamificationStats,
    getGamificationBadges,
    recordDailyUpdatePoints
} from './gamificationThunk';